export default {
    1: 'INDIVIDUAL',
    2: 'COMPANY',
  };
  